import {
	LocalPhone,
	Print,
	CalendarToday,
	Person,
	Cake,
	Favorite,
	Healing,
	Assignment,
	Schedule,
	Info,
} from "@mui/icons-material";
import {
	Box,
	Button,
	Chip,
	Divider,
	IconButton,
	Paper,
	Tooltip,
	Typography,
	Zoom,
} from "@mui/material";
import { useState } from "react";

const PhotoPrescriptionPreview = ({ prescription }) => {
	const [isExpanded, setIsExpanded] = useState(false);

	const handlePrint = () => {
		const newWindow = window.open("", "", "width=1200,height=800");
		newWindow.document.write(`
      <html>
        <head>
          <title>স্বাস্থ্য উপদেশ</title>
          <style>
            body { 
              font-family: Arial, sans-serif; 
              padding: 0;
              margin: 0;
              color: #333;
            }
            .container {
              max-width: 1200px;
              margin: 0 auto;
              background: white;
              width: 100%;
              padding-right: 20px;
            }
            .top-spacer {
              height: 2in;
            }
            .header-line {
              display: flex;
              justify-content: space-between;
              padding: 10px 20px 10px 20px;
              padding-right: 40px;
              border-bottom: 1px solid #ddd;
              width: 100%;
              box-sizing: border-box;
            }
            .header-line-1 {
              display: flex;
              gap: 30px;
              font-size: 14px;
              width: 100%;
            }
            .header-line-2 {
              display: flex;
              gap: 20px;
              font-size: 14px;
              width: 100%;
            }
            .doctor-name, .date {
              font-weight: bold;
            }
            .main-content {
              display: flex;
              width: 100%;
              padding-right: 20px;
              box-sizing: border-box;
            }
            .left-panel {
              width: 20%;
              background: #f9fafb;
              padding: 20px;
              border-right: 1px solid #e5e7eb;
              box-sizing: border-box;
            }
            .right-panel {
              width: 80%;
              padding: 20px;
              padding-right: 30px;
              box-sizing: border-box;
            }
            .section {
              margin-bottom: 20px;
            }
            .section-title {
              color: #1e40af;
              font-weight: bold;
              margin-bottom: 10px;
              font-size: 16px;
            }
            .left-section-title {
              color: #1e40af;
              font-weight: bold;
              margin-bottom: 8px;
              font-size: 14px;
            }
            ul { 
              list-style-type: disc; 
              margin-left: 20px; 
              padding-left: 15px;
            }
            li {
              padding: 3px 0;
              font-size: 14px;
            }
            .medicine-item, .test-item {
              margin-bottom: 8px;
              font-size: 14px;
            }
            .page-break {
              page-break-before: always;
              margin-top: 20px;
            }
            .medicine-usage-section {
              padding: 20px;
            }
            .medicine-usage-item {
              margin-bottom: 20px;
              padding: 15px;
              border: 1px solid #ddd;
              border-radius: 5px;
            }
            .medicine-usage-title {
              font-weight: bold;
              font-size: 16px;
              color: #1e40af;
              margin-bottom: 10px;
            }
            .usage-detail {
              margin: 5px 0;
              font-size: 14px;
            }
            @media print {
              body { 
                margin: 0;
                padding: 0 20px 0 0;
              }
              .container { 
                max-width: none;
                padding-right: 30px;
              }
              .page-break { page-break-before: always; }
              .header-line {
                padding-right: 40px;
              }
              .main-content {
                padding-right: 30px;
              }
            }
          </style>
        </head>
        <body>
          <!-- Top Spacer -->
          <div class="top-spacer"></div>
          
          <!-- Header Lines - Full Width -->
          <div style="width: 100%; display: block; padding-right: 40px; box-sizing: border-box;">
            <div class="header-line" style="width: 100%;">
              <div class="header-line-1" style="width: 100%; display: flex; justify-content: space-between;">
                <div><strong>Doctor Name:</strong> ${prescription?.doctor_name || "N/A"}</div>
                <div><strong>Date:</strong> ${new Date(prescription?.creation_date || new Date()).toLocaleDateString()}</div>
              </div>
            </div>
            <div class="header-line" style="width: 100%;">
              <div class="header-line-2" style="width: 100%; display: flex; justify-content: space-between;">
                <div><strong>Patient Name:</strong> ${prescription?.patient_name || prescription?.name || "N/A"}</div>
                <div><strong>Age:</strong> ${prescription?.patient_age || prescription?.age || "N/A"}</div>
                <div><strong>Gender:</strong> ${prescription?.patient_gender || "N/A"}</div>
              </div>
            </div>
          </div>

          <!-- Main Content -->
          <div class="container">
            <div class="main-content">
              <!-- Left Panel -->
              <div class="left-panel">
                ${
                  prescription?.cc_list && Object.keys(JSON.parse(prescription.cc_list || "{}")).length > 0
                    ? `
                    <div class="section">
                      <div class="left-section-title">Chief Complaints</div>
                      <ul>
                        ${Object.values(JSON.parse(prescription.cc_list || "{}"))
                          .map((cc) => `<li>${cc}</li>`)
                          .join("")}
                      </ul>
                    </div>
                    `
                    : ""
                }
                
                ${
                  JSON.parse(prescription?.cc_list || "{}").on_exam || JSON.parse(prescription?.advices_list || "{}").on_exam
                    ? `
                    <div class="section">
                      <div class="left-section-title">On Exam</div>
                      <div style="font-size: 14px;">
                        ${JSON.parse(prescription?.cc_list || "{}").on_exam || JSON.parse(prescription?.advices_list || "{}").on_exam}
                      </div>
                    </div>
                    `
                    : ""
                }
                
                ${
                  JSON.parse(prescription?.advices_list || "{}").diagnosis
                    ? `
                    <div class="section">
                      <div class="left-section-title">Diagnostic Comments</div>
                      <div style="font-size: 14px;">
                        ${JSON.parse(prescription?.advices_list || "{}").diagnosis}
                      </div>
                    </div>
                    `
                    : ""
                }
              </div>

              <!-- Right Panel -->
              <div class="right-panel">
                ${
                  (prescription?.medicine && Array.isArray(prescription.medicine) && prescription.medicine.length > 0) ||
                  (prescription?.medicine_list && Object.keys(JSON.parse(prescription.medicine_list || "{}")).length > 0)
                    ? `
                    <div class="section">
                      <div class="section-title">Medicines</div>
                      <ul>
                        ${
                          prescription?.medicine && Array.isArray(prescription.medicine) && prescription.medicine.length > 0
                            ? prescription.medicine.map((med) => {
                                const medicineStr = (med.name || "") + " " + (med.strength || "") + " (" + (med.type || "") + ") - " + (med.dosage || "") + " " + (med.timing || "") + " for " + (med.continueTill || "");
                                const indicationStr = med.indication ? " - Indication: " + med.indication : "";
                                return "<li class=\"medicine-item\">" + medicineStr + indicationStr + "</li>";
                              }).join("")
                            : Object.values(JSON.parse(prescription.medicine_list || "{}"))
                                .map((medicine) => "<li class=\"medicine-item\">" + medicine + "</li>")
                                .join("")
                        }
                      </ul>
                    </div>
                    `
                    : ""
                }
                
                ${
                  prescription?.radiology_tests && prescription.radiology_tests.length > 0
                    ? `
                    <div class="section">
                      <div class="section-title">Radiology Tests</div>
                      <ul>
                        ${prescription.radiology_tests.map((test) => `<li class="test-item">${test[3]} - ${test[6]}</li>`).join("")}
                      </ul>
                    </div>
                    `
                    : ""
                }
                
                ${
                  prescription?.pathology_tests && prescription.pathology_tests.length > 0
                    ? `
                    <div class="section">
                      <div class="section-title">Pathology Tests</div>
                      <ul>
                        ${prescription.pathology_tests.map((test) => `<li class="test-item">${test[3]} - ${test[5]}</li>`).join("")}
                      </ul>
                    </div>
                    `
                    : ""
                }
                
                ${
                  prescription?.advices || (prescription?.advices_list && Object.keys(JSON.parse(prescription.advices_list || "{}")).length > 0)
                    ? `
                    <div class="section">
                      <div class="section-title">Advice</div>
                      <div class="medicine-item">${prescription?.advices || Object.values(JSON.parse(prescription.advices_list || "{}")).join(", ")}</div>
                    </div>
                    `
                    : ""
                }
              </div>
            </div>
          </div>

          <!-- Medicine Usage List - Next Page -->
          ${
            prescription?.medicine_usage_list && JSON.parse(prescription?.medicine_usage_list || "[]").length > 0
              ? `
            <div class="page-break medicine-usage-section">
              <div class="section-title" style="font-size: 18px; margin-bottom: 20px;">Medicine Usage Details</div>
              ${JSON.parse(prescription?.medicine_usage_list || "[]")
                .map(
                  (usage, index) => `
                <div class="medicine-usage-item">
                  <div class="medicine-usage-title">${index + 1}. ${usage.drugname || "N/A"}</div>
                  <div class="usage-detail"><strong>Duration:</strong> ${usage.medicine_usage?.duration || "N/A"}</div>
                  <div class="usage-detail"><strong>Physiological Effect:</strong> ${usage.medicine_usage?.physiological_effect || "N/A"}</div>
                  <div class="usage-detail"><strong>Primary Usage:</strong> ${usage.medicine_usage?.primary_usage || "N/A"}</div>
                  <div class="usage-detail"><strong>Typical Dose:</strong> ${usage.medicine_usage?.typical_dose || "N/A"}</div>
                  <div class="usage-detail"><strong>With Meal:</strong> ${usage.medicine_usage?.with_meal || "N/A"}</div>
                </div>
              `
                )
                .join("")}
            </div>
            `
              : ""
          }
        </body>
      </html>
    `);

		newWindow.document.close();
		newWindow.focus();
		setTimeout(() => {
			newWindow.print();
			newWindow.close();
		}, 500);
	};

	// Function to safely parse JSON with a fallback
	const safeParseJSON = (jsonString, fallback) => {
		try {
			return jsonString ? JSON.parse(jsonString) : fallback;
		} catch (error) {
			console.error("Error parsing JSON:", error);
			return fallback;
		}
	};

	const vitals = safeParseJSON(prescription?.vitals, {});
	const ccList = safeParseJSON(prescription?.cc_list, {});
	const medicineList = safeParseJSON(prescription?.medicine_list, {});
	const advicesList = safeParseJSON(prescription?.advices_list, {});
	const medicineUsageList = safeParseJSON(
		prescription?.medicine_usage_list,
		[]
	);
	
	// Parse additional fields from advices_list
	const diagnosis = advicesList.diagnosis || "";
	const onExam = advicesList.on_exam || "";
	// Get advices directly from prescription
	const advices = prescription?.advices || "";
	
	// Parse pathology and radiology tests from prescription
	const pathologyTests = prescription?.pathology_tests || [];
	const radiologyTests = prescription?.radiology_tests || [];

	return (
		<Paper className="max-w-2xl mx-auto bg-white rounded-lg shadow-lg border border-blue-100 overflow-hidden">
			{/* Header Section */}
			<Box className="bg-gradient-to-r from-blue-600 to-blue-800 p-4 text-white">
				<Typography variant="h4" className="font-bold text-center">
					{prescription?.organization_name || "স্বাস্থ্য উপদেশ"}
				</Typography>
				<Box className="flex justify-between items-center mt-2">
					<Box className="flex items-center">
						<CalendarToday fontSize="small" className="mr-1" />
						<Typography variant="body2">
							{new Date(
								prescription?.creation_date || new Date()
							).toLocaleDateString()}
						</Typography>
					</Box>
					<Box className="flex gap-2">
						<Tooltip title="Print Prescription">
							<IconButton
								onClick={handlePrint}
								size="small"
								className="bg-white text-blue-800"
							>
								<Print />
							</IconButton>
						</Tooltip>
					</Box>
				</Box>
			</Box>

			{/* Doctor Info */}
			<Box className="bg-blue-50 px-6 py-2 flex items-center">
				<Person className="text-blue-600 mr-2" />
				<Typography variant="subtitle1" className="font-medium">
					ডাক্তার: {prescription?.doctor_name || "N/A"}
				</Typography>
			</Box>

			{/* Patient Information */}
			<Box className="px-6 py-4 bg-white">
				<Box className="flex flex-wrap gap-4 justify-between mb-4 p-3 bg-blue-50 rounded-lg">
					<Box className="flex items-center">
						<Person className="text-blue-600 mr-2" />
						<Typography>
							<span className="font-semibold">নাম:</span>{" "}
							{prescription?.patient_name || prescription?.name || "N/A"}
						</Typography>
					</Box>
					<Box className="flex items-center">
						<Cake className="text-blue-600 mr-2" />
						<Typography>
							<span className="font-semibold">বয়স:</span>{" "}
							{prescription?.patient_age || prescription?.age || "N/A"}, {prescription?.patient_gender || "N/A"}
						</Typography>
					</Box>
				</Box>

				{/* Chief Complaints */}
				{Object.keys(ccList).length > 0 && (
					<Box className="mb-4">
						<Box className="flex items-center mb-2">
							<Info className="text-blue-600 mr-2" />
							<Typography
								variant="h6"
								className="font-semibold text-blue-800"
							>
								Chief Complaints
							</Typography>
						</Box>
						<Divider className="mb-2" />
						<ul className="list-disc ml-8">
							{Object.values(ccList).map((cc, index) => (
								<li
									key={index}
									className="py-1 text-gray-800"
								>
									{cc}
								</li>
							))}
						</ul>
					</Box>
				)}

				{/* On Exam */}
				{onExam && (
					<Box className="mb-4">
						<Box className="flex items-center mb-2">
							<Info className="text-blue-600 mr-2" />
							<Typography
								variant="h6"
								className="font-semibold text-blue-800"
							>
								On Exam
							</Typography>
						</Box>
						<Divider className="mb-2" />
						<Typography className="py-1 text-gray-800 ml-8">
							{onExam}
						</Typography>
					</Box>
				)}

				{/* Diagnosis */}
				{diagnosis && (
					<Box className="mb-4">
						<Box className="flex items-center mb-2">
							<Info className="text-blue-600 mr-2" />
							<Typography
								variant="h6"
								className="font-semibold text-blue-800"
							>
								Diagnosis
							</Typography>
						</Box>
						<Divider className="mb-2" />
						<Typography className="py-1 text-gray-800 ml-8">
							{diagnosis}
						</Typography>
					</Box>
				)}



				{/* Pathology Tests */}
				{pathologyTests.length > 0 && (
					<Box className="mb-4">
						<Box className="flex items-center mb-2">
							<Assignment className="text-blue-600 mr-2" />
							<Typography
								variant="h6"
								className="font-semibold text-blue-800"
							>
								Pathology Tests
							</Typography>
						</Box>
						<Divider className="mb-2" />
						<ul className="list-disc ml-8">
							{pathologyTests.map((test, index) => (
								<li
									key={index}
									className="py-1 text-gray-800"
								>
									{test[3]} - {test[5]}
								</li>
							))}
						</ul>
					</Box>
				)}

				{/* Radiology Tests */}
				{radiologyTests.length > 0 && (
					<Box className="mb-4">
						<Box className="flex items-center mb-2">
							<Assignment className="text-blue-600 mr-2" />
							<Typography
								variant="h6"
								className="font-semibold text-blue-800"
							>
								Radiology Tests
							</Typography>
						</Box>
						<Divider className="mb-2" />
						<ul className="list-disc ml-8">
							{radiologyTests.map((test, index) => (
								<li
									key={index}
									className="py-1 text-gray-800"
								>
									{test[3]} - {test[6]}
								</li>
							))}
						</ul>
					</Box>
				)}

				{/* Vitals */}
				{Object.keys(vitals).length > 0 && (
					<Box className="mb-4">
						<Box className="flex items-center mb-2">
							<Favorite className="text-blue-600 mr-2" />
							<Typography
								variant="h6"
								className="font-semibold text-blue-800"
							>
								গুরুত্বপূর্ণ
							</Typography>
						</Box>
						<Divider className="mb-2" />
						<Box className="flex flex-wrap gap-2 mt-2">
							{vitals.BP && (
								<Chip
									label={`রক্তচাপ: ${vitals.BP}`}
									className="bg-red-50 text-red-800"
								/>
							)}
							{vitals.DM && (
								<Chip
									label={`DM: ${vitals.DM}`}
									className="bg-orange-50 text-orange-800"
								/>
							)}
							{vitals.HTN && (
								<Chip
									label={`HTN: ${vitals.HTN}`}
									className="bg-purple-50 text-purple-800"
								/>
							)}
							{vitals.pulse && (
								<Chip
									label={`Pulse: ${vitals.pulse}`}
									className="bg-blue-50 text-blue-800"
								/>
							)}
							{vitals.weight && (
								<Chip
									label={`Weight: ${vitals.weight} kg`}
									className="bg-green-50 text-green-800"
								/>
							)}
						</Box>
					</Box>
				)}

				{/* Medicines */}
				{Object.keys(medicineList).length > 0 && (
					<Box className="mb-4">
						<Box className="flex items-center mb-2">
							<Healing className="text-blue-600 mr-2" />
							<Typography
								variant="h6"
								className="font-semibold text-blue-800"
							>
								ঔষধ সমূহ
							</Typography>
						</Box>
						<Divider className="mb-2" />
						<ul className="list-disc ml-8">
							{Object.values(medicineList).map(
								(medicine, index) => (
									<li
										key={index}
										className="py-1 text-gray-800"
									>
										{medicine}
									</li>
								)
							)}
						</ul>
					</Box>
				)}

				{/* Advice */}
				{advices && (
					<Box className="mb-4">
						<Box className="flex items-center mb-2">
							<Assignment className="text-blue-600 mr-2" />
							<Typography
								variant="h6"
								className="font-semibold text-blue-800"
							>
								পরামর্শ
							</Typography>
						</Box>
						<Divider className="mb-2" />
						<Typography className="py-1 text-gray-800 ml-8">
							{advices}
						</Typography>
					</Box>
				)}

				{/* Follow-up */}
				{prescription?.followup && (
					<Box className="mb-4">
						<Box className="flex items-center mb-2">
							<Schedule className="text-blue-600 mr-2" />
							<Typography
								variant="h6"
								className="font-semibold text-blue-800"
							>
								Follow-up
							</Typography>
						</Box>
						<Divider className="mb-2" />
						<Typography className="py-1 text-gray-800 ml-8">
							{prescription.followup}
						</Typography>
					</Box>
				)}

				{/* Medicine Usage - Toggle Expandable */}
				{medicineUsageList.length > 0 && (
					<Box className="mb-4">
						<Button
							fullWidth
							variant="contained"
							color="primary"
							onClick={() => setIsExpanded(!isExpanded)}
							className="text-left mb-2"
							sx={{
								justifyContent: "flex-start",
								backgroundColor: "#3b82f6",
								":hover": {
									backgroundColor: "#2563eb",
								},
							}}
						>
							<Box className="flex items-center">
								<Info className="mr-2" />
								<Typography>
									{isExpanded ? "Hide" : "Show"} ঔষুধের
									ব্যবহার বিস্তারিত
								</Typography>
							</Box>
						</Button>

						{isExpanded && (
							<Box className="mt-2 bg-blue-50 p-4 rounded-lg">
								{medicineUsageList.map((usage, index) => (
									<Box
										key={index}
										className={`mb-4 p-4 bg-white rounded-lg shadow-sm border-l-4 border-blue-500 ${
											index !==
											medicineUsageList.length - 1
												? "mb-4"
												: ""
										}`}
									>
										<Typography
											variant="h6"
											className="font-semibold text-blue-800 mb-2"
										>
											{index + 1}. {usage.drugname}
										</Typography>
										<Box className="grid grid-cols-1 gap-x-4 gap-y-2">
											<Box className="flex items-start">
												<Typography
													variant="body2"
													className="font-medium min-w-32 text-gray-600"
												>
													ব্যবহারের সময়কাল:
												</Typography>
												<Typography
													variant="body2"
													className="text-gray-800"
												>
													{usage.medicine_usage
														?.duration || "N/A"}
												</Typography>
											</Box>
											{/* <Box className="flex items-start">
												<Typography
													variant="body2"
													className="font-medium min-w-32 text-gray-600"
												>
													ঔষধের নাম:
												</Typography>
												<Typography
													variant="body2"
													className="text-gray-800"
												>
													{usage.medicine_usage
														?.medicine_name ||
														"N/A"}
												</Typography>
											</Box> */}
											<Box className="flex items-start">
												<Typography
													variant="body2"
													className="font-medium min-w-32 text-gray-600"
												>
													শারীরবৃত্তীয় প্রভাব:
												</Typography>
												<Typography
													variant="body2"
													className="text-gray-800"
												>
													{usage.medicine_usage
														?.physiological_effect ||
														"N/A"}
												</Typography>
											</Box>
											<Box className="flex items-start">
												<Typography
													variant="body2"
													className="font-medium min-w-32 text-gray-600"
												>
													প্রাথমিক ব্যবহার:
												</Typography>
												<Typography
													variant="body2"
													className="text-gray-800"
												>
													{usage.medicine_usage
														?.primary_usage ||
														"N/A"}
												</Typography>
											</Box>
											<Box className="flex items-start">
												<Typography
													variant="body2"
													className="font-medium min-w-32 text-gray-600"
												>
													সাধারণ ডোজ:
												</Typography>
												<Typography
													variant="body2"
													className="text-gray-800"
												>
													{usage.medicine_usage
														?.typical_dose ||
														"N/A"}
												</Typography>
											</Box>
											<Box className="flex items-start">
												<Typography
													variant="body2"
													className="font-medium min-w-32 text-gray-600"
												>
													খাবারের সাথে গ্রহণ:
												</Typography>
												<Typography
													variant="body2"
													className="text-gray-800"
												>
													{usage.medicine_usage
														?.with_meal ||
														"N/A"}
												</Typography>
											</Box>
										</Box>
									</Box>
								))}
							</Box>
						)}
					</Box>
				)}

				{/* Warning Note */}
				{/* <Box className="p-3 border-l-4 border-yellow-500 bg-yellow-50 rounded-r mb-4">
					<Typography variant="body2" className="text-yellow-800">
						<sup>1.</sup> এটি একটি প্রাথমিক রূপরেখা। রেজিস্টার্ড
						ডাক্তারের পরামর্শ নিয়ে ওষুধ সেবন করুন।
					</Typography>
				</Box> */}
			</Box>

			{/* Footer Section */}
			<Box className="bg-red-100 p-3 flex justify-between items-center">
				<Button
					variant="contained"
					startIcon={<Print />}
					onClick={handlePrint}
					className="bg-blue-600 hover:bg-blue-700"
				>
					প্রিন্ট করুন
				</Button>
				<Box className="flex items-center text-red-800">
					<LocalPhone className="mr-1" fontSize="small" />
					<Typography variant="body2" className="font-semibold">
					Org Phone: {prescription?.organization_phone || "N/A"}
					</Typography>
				</Box>
			</Box>
		</Paper>		
	);
};

export default PhotoPrescriptionPreview;
